module.exports = __webpack_public_path__ + "img/run-download-simulation.d29a8601.png";